import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/services/products.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DialogDeleteProductComponent } from 'src/app/components/dialogs/dialog-delete-product/dialog-delete-product.component';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {

  public productID: string;
  public product;
  public pictureURL;
  private picture: File;

  constructor(private productsService: ProductsService, private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  categories = [
    { value: 'Leaves', viewValue: 'Leaves' },
    { value: 'Dressings', viewValue: 'Dressings' }
  ];

  measurements = [
    { value: 'grams', viewValue: 'GRAMS' },
    { value: 'ml', viewValue: 'ML' }
  ];

  status = [
    { value: 'true', viewValue: 'Enable' },
    { value: 'false', viewValue: 'Disable' }
  ]

  ngOnInit() {

    this.route.paramMap.subscribe((paraMap: ParamMap) => {
      if (paraMap.has('id')) {
        this.productID = paraMap.get('id');

        const data = new FormData();

        data.append('_id', this.productID)

        this.productsService.getProductAsAdmin(data).subscribe(result => {
          if (result.success) {
            this.product = result.data[0];
            this.pictureURL = this.product.picture;
          }
        }, error => {
          this.snackBar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    });
  }

  onPictureSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.picture = file;

    this.pictureURL = URL.createObjectURL(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (file) => {
      this.pictureURL = reader.result.toString();
    }
  }

  onSave(form: NgForm) {
    const product = new FormData();
    product.append('_id', this.productID);
    product.append('name', form.value.name);
    product.append('picture', this.picture);
    product.append('price', form.value.price);
    product.append('subscriptionPrice', form.value.subscriptionPrice);
    product.append('enable', form.value.enable);
    product.append('category', form.value.category);
    product.append('code', form.value.code);
    product.append('minimumWeight', form.value.minimumWeight);
    product.append('unitOfMeasurement', form.value.unitOfMeasurement);
    product.append('description', form.value.description);

    this.productsService.updateProduct(product);
  }

  onDelete(ID) {
    this.dialog.open(DialogDeleteProductComponent, {
      data: {
        _id: ID
      }
    })
  }

  onCalcel() {
    this.router.navigate(['/admin/products']);
  }
}
